/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchServiceCentersResponse } from './search-service-centers-response';


export interface SearchServiceCentersResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchServiceCentersResponse> | null;
}

